import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "../../utils/apis";

export const getDonationById = createAsyncThunk(
  "Messages/getDonationById",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const rsp = await API.getDataApi(
        `Donation/GetDonationById/${data.donationId}`,
        token
      );
      return rsp.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getReceiverDetailById = createAsyncThunk(
  "Messages/getReceiverDetailById",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const rsp = await API.getDataApi(
        `Registration/GetEntityDetailsById/${data.entityId}`,
        token
      );
      return rsp.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getDonationEntityDetailById = createAsyncThunk(
  "Messages/getDonationEntityDetailById",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const rsp = await API.getDataApi(
        `Registration/GetEntityDetailsById/${data.entityId}`,
        token
      );
      return rsp.data;
    } catch (error) {
      throw error;
    }
  }
);

const initialState = {
  chatDonationDetail: {},
  recevierEntityDetail: {},
  donationEntityDetail: {},
};

export const messageSlice = createSlice({
  name: "Messages",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(getDonationById.pending, (state, action) => {
        state.status = "in-progress";
      })
      .addCase(getDonationById.fulfilled, (state, action) => {
        state.status = "idle";
        state.chatDonationDetail = action.payload.donationId.donations;
      })
      .addCase(getDonationById.rejected, (state, action) => {
        state.status = "idle";
      })
      .addCase(getReceiverDetailById.pending, (state, action) => {
        state.status = "in-progress";
      })
      .addCase(getReceiverDetailById.fulfilled, (state, action) => {
        state.status = "idle";
        state.recevierEntityDetail = action.payload;
      })
      .addCase(getReceiverDetailById.rejected, (state, action) => {
        state.status = "idle";
      })
      .addCase(getDonationEntityDetailById.pending, (state, action) => {
        state.status = "in-progress";
      })
      .addCase(getDonationEntityDetailById.fulfilled, (state, action) => {
        state.status = "idle";
        state.donationEntityDetail = action.payload;
      })
      .addCase(getDonationEntityDetailById.rejected, (state, action) => {
        state.status = "idle";
      });
  },
});
//   export const {
//   } = donationSlice.actions;

export default messageSlice.reducer;
